import { TGetJobLedgerListReqDto, TGetJobLedgerListResDto } from "@/api/services/main/job-ledger/dtos/get-job-ledger-list.dto";
import { TUpdateJobLedgerNoteReqDto, TUpdateJobLedgerNoteResDto, } from "@/api/services/main/job-ledger/dtos/update-job-ledger-note.dto";
import { TUpdateJobLedgerEmploymentPeriodReqDto, TUpdateJobLedgerEmploymentPeriodResDto } from "@/api/services/main/job-ledger/dtos/update-job-ledger-employment-period.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
export const getJobLedgerListApi = async (params: TGetJobLedgerListReqDto): Promise<TGetJobLedgerListResDto> => {
    const { data } = await clientApi.get<TGetJobLedgerListResDto>("/ledger/job-ledger", { params });
    return data;
};
export type TExportJobLedgerReqDto = {
    fiscalYear: number;
};
export const exportJobLedgerApi = async (params: TExportJobLedgerReqDto) => {
    return await clientApi.get<Blob>("/ledger/job-ledger/export", { params, responseType: "blob" });
};
export const useJobLedgerList = (params: TGetJobLedgerListReqDto, enabled = true) => {
    return useQuery({
        queryKey: [QUERY_KEYS.JOB.FETCH_LEDGER_LIST, params],
        queryFn: () => getJobLedgerListApi(params),
        enabled,
    });
};
export const updateJobLedgerNoteApi = async (caseMatchId: number, payload: TUpdateJobLedgerNoteReqDto): Promise<TUpdateJobLedgerNoteResDto> => {
    const { data } = await clientApi.patch<TUpdateJobLedgerNoteResDto>(`/ledger/job-ledger/notes/${caseMatchId}`, payload);
    return data;
};
export type TJobLedgerNotePatch = {
    caseMatchId: number;
    payload: TUpdateJobLedgerNoteReqDto;
};
export const useFlushJobLedgerNotes = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (patches: TJobLedgerNotePatch[]) => Promise.all(patches.map(({ caseMatchId, payload }) => updateJobLedgerNoteApi(caseMatchId, payload))),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.JOB.FETCH_LEDGER_LIST] });
        },
    });
};
export const updateJobLedgerEmploymentPeriodApi = async (jobId: number, payload: TUpdateJobLedgerEmploymentPeriodReqDto): Promise<TUpdateJobLedgerEmploymentPeriodResDto> => {
    const { data } = await clientApi.patch<TUpdateJobLedgerEmploymentPeriodResDto>(`/ledger/job-ledger/jobs/${jobId}`, payload);
    return data;
};
export type TJobLedgerEmploymentPeriodPatch = {
    jobId: number;
    payload: TUpdateJobLedgerEmploymentPeriodReqDto;
};
export const useFlushJobLedgerEmploymentPeriods = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (patches: TJobLedgerEmploymentPeriodPatch[]) => Promise.all(patches.map(({ jobId, payload }) => updateJobLedgerEmploymentPeriodApi(jobId, payload))),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.JOB.FETCH_LEDGER_LIST] });
        },
    });
};
